import {
  Pipe,
  PipeTransform
} from '@angular/core';

@Pipe({name: 'round'})
export class RoundPipe implements PipeTransform {
  /**
   * Rounds a number and returns it.
   * @see: http://blog.bastien-donjon.fr/round-number-angular-2-pipe/
   *
   * @param value
   * @returns {number}
   */
  transform(value: number): number {
    return Math.round(value);
  }
}
